import { TodoAssignmentContent } from '@endpoint/endpoint-bff-graphql-schema';

export const getUniqueStepComponentKey = (content: TodoAssignmentContent, index: number) => {
  if (content.field) {
    return content.field.id;
  }

  return index;
};
